var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loader',{attrs:{"loader-primario":_vm.loader}}),_c('v-container',[_c('div',{staticClass:"card"},[_c('BancoHoras',{attrs:{"active-tab":"tab-0"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }